<template>
  <div class="header colorHeader">
    <h2
      id="title"
      :style="[
        !hasToken
          ? { right: '50px' }
          : isMobile
          ? { right: '30px' }
          : { right: '330px' },
      ]"
    >
      {{ title }}
    </h2>

    <div class="buttons">
      <app-select-role />

      <v-btn
        v-if="!isMobile && currentBranch && isAdmin"
        class="admin-button"
        color="cyan white--text"
        @click="removeCurrentBranch"
        rounded
      >
        بازگشت به منوی اصلی
      </v-btn>

      <v-btn
        v-if="isMobile"
        class="home-button"
        color="cyan white--text"
        @click="goToIndex"
        rounded
      >
        <font-awesome-icon icon="home" size="lg" />
      </v-btn>
    </div>
  </div>
</template>
 <script>
import { getToken, setCurrentBranch } from "@/utils/auth";
import selectRole from "@/components/SelectRole";

export default {
  components: {
    appSelectRole: selectRole,
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    title() {
      return this.$store.getters.headerTitle;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    hasToken() {
      return this.$store.getters.token != "" && getToken();
    },
    currentBranch() {
      return this.$store.getters.currentBranch;
    },
  },

  methods: {
    goToIndex() {
      this.$store.commit("SET_DIALOG_SHOW", false);
      setCurrentBranch("");
      window.location = "/index";
    },
    removeCurrentBranch() {
      setCurrentBranch("");

      window.location = "/branch";
    },
  },
};
</script>
<style scoped>
#title {
  color: white;
  position: fixed;
  top: 20px;
  right: 100px;
  font-size: 1.2em;
}

.header {
  height: 60px;
  position: fixed;
  width: 100%;
  z-index: 2;
  padding-bottom: 5px;
  font-size: 12px;
}

.home-button {
  height: 40px !important;
  margin-right: 10px;
  width: 40px;
  top: 10px;
  min-width: 40px !important;
}

.admin-button {
  height: 40px !important;
  top: 10px;
  margin-right: 10px;
}
.buttons {
  position: fixed;
  left: 10px;
  display: flex;
}
</style>
